if (!customElements.get('scrolling-collection-awards')) {
    class ScrollingCollectionAwards extends HTMLElement {
      constructor() {
        super();
        if (FoxTheme.config.motionReduced) return;
        this.promotion = this.querySelector('.promotion');
        this.hasInitialized = false;
        this.resizeHandler = this.handleResize.bind(this);
        this.baseDuration = parseFloat(getComputedStyle(this).getPropertyValue('--duration')) || 6;
        this.lastWidth = window.innerWidth;
        this.breakpoint = 768;
        FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
      }
  
      init() {
        if (this.childElementCount === 1) {
          this.setupScrolling();
          window.addEventListener('resize', this.resizeHandler);
        }
      }
  
      handleResize() {
        // Debounce the resize event
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
        
        this.resizeTimeout = setTimeout(() => {
          const currentWidth = window.innerWidth;
          const wasMobile = this.lastWidth < this.breakpoint;
          const isMobile = currentWidth < this.breakpoint;
          
          // Reinitialize if we've crossed the breakpoint
          if (wasMobile !== isMobile) {
            this.cleanup();
            this.setupScrolling();
          }
          
          this.lastWidth = currentWidth;
        }, 250);
      }
  
      cleanup() {
        // Remove all cloned elements
        while (this.childElementCount > 1) {
          this.removeChild(this.lastChild);
        }
        this.promotion.classList.remove('promotion--animated');
        this.promotion.style.animationDuration = '';
        this.hasInitialized = false;
      }
  
      setupScrolling() {
        const isMobile = window.innerWidth < this.breakpoint;
        
        // Always animate on mobile, never on desktop
        if (isMobile) {
          this.promotion.classList.add('promotion--animated');
          
          // Calculate the number of clones needed based on screen width
          const screenWidth = window.innerWidth;
          const itemWidth = this.promotion.querySelector('.promotion__item').offsetWidth;
          const visibleItems = Math.ceil(screenWidth / itemWidth);
          const numClones = Math.max(visibleItems + 2, 10);
          
          // Add new clones
          for (let index = 0; index < numClones; index++) {
            this.clone = this.promotion.cloneNode(true);
            this.appendChild(this.clone);
          }
  
          // Set the animation duration from CSS custom property
          this.promotion.style.animationDuration = `${this.baseDuration}s`;
          
          // pause when out of view
          if (!this.hasInitialized) {
            const observer = new IntersectionObserver(
              (entries, _observer) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this.scrollingPlay();
                  } else {
                    this.scrollingPause();
                  }
                });
              },
              { rootMargin: '0px 0px 50px 0px' }
            );
  
            observer.observe(this);
          }
          
          this.hasInitialized = true;
        } else {
          // For desktop, just ensure the promotion is static (no animation)
          this.promotion.classList.add('promotion--static');
        }
      }
  
      scrollingPlay() {
        this.classList.remove('scrolling-promotion--paused');
      }
  
      scrollingPause() {
        this.classList.add('scrolling-promotion--paused');
      }
  
      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
    customElements.define('scrolling-collection-awards', ScrollingCollectionAwards);
  }
  